import Table from "react-bootstrap/Table";
import "./HabitBuilderTable.scss";
import { getHBScoreColor } from "../../../utils/generalUtils";

function HabitBuilderTable({ columns, data }) {
  const renderHeaders = () => {
    let headersTh = [];
    for (let column of columns) {
      headersTh.push(
        <th className={column.headerClass} style={{ width: column.width }}>
          {column.title}
        </th>,
      );
    }
    return <tr>{headersTh}</tr>;
  };

  const renderData = () => {
    let rows = [];
    let rowIndex = 0;
    for (let record of data) {
      let columnElements = [];
      for (let column of columns) {
        if (column.formatter) {
          columnElements.push(
            <td key={`${rowIndex}-${column.dataField}`}>
              {column.formatter(record, rowIndex)}
            </td>,
          );
          continue;
        }
        let color;
        if (column.colored) {
          color = getHBScoreColor(record[column.dataField]);
        }
        columnElements.push(
          <td key={`${rowIndex}-${column.dataField}`} style={{ color: color }}>
            {record[column.dataField]}
          </td>,
        );
      }
      rows.push(<tr key={rowIndex}>{columnElements}</tr>);
      rowIndex++;
    }
    return rows;
  };
  return (
    <Table hover className="habit-builder-table">
      <thead>{renderHeaders()}</thead>
      <tbody>{renderData()}</tbody>
    </Table>
  );
}

export default HabitBuilderTable;
